import { cloneDeep } from "lodash";
import { checkChanged } from "./checkChanged";
import { ITlfActionUpdateTlf, TlfContextProps, UPDATE_TLF } from "./interface";

/**
 * Merges TLF changes into state and maintains undo/save history.
 *
 * @param state - Current TLF context state.
 * @param action - Update action containing changed TLF fields and history flags.
 * @returns Updated state with the merged TLF data and refreshed history metadata.
 */
export const tlf_updateTlf = (
  state: TlfContextProps,
  action: ITlfActionUpdateTlf,
): TlfContextProps => {
  if (!state.tlfData) {
    throw new Error(`tlfContextReducer: ${UPDATE_TLF}: TLF data not set`);
  }

  const newState = { ...state };
  const newTlfData = {
    ...state.tlfData,
    ...action.tlfData,
  };
  newState.tlfData = newTlfData;

  if (action.reset) {
    newState.ixTlfDataVersion = 0;
    newState.ixSaveVersion = 0;
    newState.tlfDataVersions = [cloneDeep(newTlfData)];
    newState.showModalWindow = "";
    newState.forcePushToParent = true;
  } else if (action.newSavePoint) {
    newState.ixSaveVersion = state.ixTlfDataVersion;
    newState.tlfDataVersions = [
      ...state.tlfDataVersions.slice(0, state.ixTlfDataVersion),
      cloneDeep(newTlfData),
    ];
    newState.showModalWindow = "";
    newState.forcePushToParent = true;
  } else if (action.doNotAddUndo) {
    newState.ixTlfDataVersion = state.ixTlfDataVersion;
    newState.tlfDataVersions = [
      ...state.tlfDataVersions.slice(0, state.ixTlfDataVersion),
      cloneDeep(newTlfData),
    ];
    newState.forcePushToParent = true;
  } else {
    if (state.ixSaveVersion > state.ixTlfDataVersion) {
      newState.ixSaveVersion = -1;
    }
    newState.ixTlfDataVersion = state.ixTlfDataVersion + 1;
    newState.tlfDataVersions = [
      ...state.tlfDataVersions.slice(0, newState.ixTlfDataVersion),
      cloneDeep(newTlfData),
    ];
  }

  checkChanged(newState);

  return newState;
};
